import apiConfig from './apiConfig'
export default {
  install (vue) {
    const ApiConfig = apiConfig(vue.prototype)
    // TODO: Implement caching on api content
    vue.prototype.$api = {
    }
  },
}
